<div class="notfound-image">
    <img src="/assets/images/404.png" alt="Page Not Found" />
</div>
<div class="text-center">
    <h2 class="notfound-title">Opps! &nbsp;Page not found</h2>
    <p class="notfound-description">ไม่พบหน้านี้ในระบบ</p>
    <button (click)="onClickBackToLandingPage()">กลับสู่หน้าหลัก</button>
</div>
